import React from 'react';
import './stylesheets/default/Calendar.css';
import './stylesheets/flat/CalendarFlat.css';
import './stylesheets/neumorphism/CalendarNeumorphism.css';
import './stylesheets/neobrutalism/CalendarNeobrutalism.css';
import './stylesheets/glassmorphism/CalendarGlassmorphism.css';


const Calendar = ({style}) => {
  const today = new Date();
  const year = today.getFullYear();
  const month = today.getMonth();
  const currentDate = today.getDate();

  const firstDayOfMonth = new Date(year, month, 1);
  const lastDayOfMonth = new Date(year, month + 1, 0);
  const daysInMonth = lastDayOfMonth.getDate();
  const startDay = firstDayOfMonth.getDay();

  const dates = [];
  for (let i = 0; i < startDay; i++) dates.push(null);
  for (let day = 1; day <= daysInMonth; day++) dates.push(day);

  return (
    <div className={`calendar-${style}`}>
      <div className={`calendar-header-${style}`}>
        {today.toLocaleString('default', { month: 'long' })} {year}
      </div>
      <div className={`calendar-grid-${style}`}>
        {['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].map((d) => (
          <div key={d} className={`calendar-day-name-${style}`}>{d}</div>
        ))}
        {dates.map((date, index) => {
          const isToday = date === currentDate;
          return (
            <div
              key={index}
              className={`calendar-cell-${style} ${isToday ? 'today' : ''}-${style}`}
            >
              {date || ''}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Calendar;
